import {initHypertune} from "./generated/hypertune";

const hypertune = initHypertune();

export default hypertune;
